import { createContext } from 'react';

const FocusManagerContext = /*#__PURE__*/createContext(undefined);

export { FocusManagerContext };
